import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { CreateNewPasswordPage } from '../create-new-password/create-new-password';
import { SetNewPasswordPage } from '../set-new-password/set-new-password';
import {UpdateofficialemailPage} from '../updateofficialemail/updateofficialemail';
import {ContactdetailsupdatePage} from '../contactdetailsupdate/contactdetailsupdate';
import {UpdateladlinenumberPage} from '../updateladlinenumber/updateladlinenumber';


declare var window:any;

/**
 * Generated class for the OtpPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-otp',
  templateUrl: 'otp.html',
})
export class OtpPage {
  mobileNumber:any;
  otp0:any;
  otp1:any;
  otp2:any;
  otp3:any;
  otp4:any;
  otp5:any;
  errorDisplay: any;
  upcheckbox:any=false;
  downcheckbox:any=true;
  type:any="mobile number";
  otptype:any=''
  encriptedMobile : any;
  encriptedEmail : any;
  disabled:any=false;
  timer:any=0;
  captcha:any="";
  constructor(private loadingCtrl:LoadingController,public navCtrl: NavController,
  private alertCtrl:AlertController, public navParams: NavParams,private cp:CommonProvider,private fv:GenericFormValidationProvider) {
    //console.log(this.navParams,this.navParams.get("type"),"contact otp ");
    
    if(this.navParams.get("code")){
      this.mobileNumber=this.navParams.get("mobile");
      this.mobileNumber=this.navParams.get("code")+this.navParams.get("mobile");
      this.encriptedMobile = this.navParams.get("mobile").substr(this.navParams.get("mobile").length - 4);
    }else if(this.navParams.get("type")=='updateemail'){
      this.mobileNumber=localStorage.getItem('mobile');
      this.mobileNumber=localStorage.getItem('mobile');
      this.encriptedMobile = localStorage.getItem('mobile').substr(localStorage.getItem('mobile').length - 4);
    }else if(this.navParams.get("type")=='updateeladline'){
      this.mobileNumber=localStorage.getItem('mobile');
      this.mobileNumber=localStorage.getItem('mobile');
      this.encriptedMobile = localStorage.getItem('mobile').substr(localStorage.getItem('mobile').length - 4);
      console.log("this.encriptedMobile ladline",this.encriptedMobile);
    }else{
      this.mobileNumber=this.navParams.get("mobile");
      this.encriptedMobile = this.navParams.get("mobile").substr(this.navParams.get("mobile").length - 4);
    }
    
    
    
    
  }
  changeUpCheckbox(checked){
    this.upcheckbox=checked;
  }
  gotoNextField(e){
    //console.log(e)
    if(e.keyCode=="8"){
      if(e.target.name == "otp0"){

      }else{
        e.target.previousElementSibling.focus()
      }

    }else{
      e.target.nextElementSibling.focus();
    }
    
        // nextElement.setFocus();
    }
    previousClick(e){
      if(e.keyCode=="8"){
        e.target.previousElementSibling.focus()
      }
    }
  ionViewDidLoad() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    if(this.navParams.get("type")=='email'){
      this.type='Email ID'
      this.cp.generatecp()
      this.cp.generateEmailOtp(loading,this.mobileNumber).then(res=>loading.dismiss())
    }
    else if(this.navParams.get("type")=='updatemobile'){
      this.type='Mobile Number and Email Id'
      this.otptype='updatemobile'
      
      this.encriptedEmail=this.navParams.data.queryParams.emailid.substr(this.navParams.data.queryParams.emailid.length - 8);
       console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.data.queryParams.emailid);
       this.cp.generatecp()
      this.cp.generateMobileEmailOtp(loading,this.mobileNumber,this.navParams.data.queryParams.emailid).then(res=>loading.dismiss())
    }
    else if(this.navParams.get("type")=='updateemail'){
      this.type='Email Id and Mobile Number'
      this.otptype='updateemail'
      this.cp.generatecp()
      this.encriptedEmail=this.navParams.data.queryParams.emailid.substr(this.navParams.data.queryParams.emailid.length - 8);
       //console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.data.queryParams.emailid);

      this.cp.generateMobileEmailOtp(loading,localStorage.getItem('mobile'),this.navParams.get('email')).then(res=>loading.dismiss())
    }
    else if(this.navParams.get("type")=='updateeladline'){
       this.type='Email Id and Mobile Number'
      this.otptype='updateeladline'
      this.cp.generatecp()
      this.encriptedEmail=this.navParams.data.queryParams.emailid.substr(this.navParams.data.queryParams.emailid.length - 8);
       //console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.data.queryParams.emailid);
      this.cp.generateMobileEmailOtp(loading,localStorage.getItem('mobile'),this.navParams.get('email')).then(res=>loading.dismiss())
    
    }

     
    else{
      if(this.navParams.get("type")=='updateemail' || this.navParams.get("type")=='updatemobile') {

      }else{
        if(this.navParams.get("captcha") && sessionStorage.getItem("code") && this.cp.checkCaptcha(this.navParams.get("captcha"),sessionStorage.getItem("code")))
        {
          //this.cp.generatecp()
          this.cp.generateOtp(loading,this.mobileNumber).then((res:any)=>{loading.dismiss()
            sessionStorage.removeItem("code");
            console.log("tp",res)
        })
        }else{
          alert("Invalid captcha");
        }
      }
      
    }

   
  }
  resendOtp(){
    window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: "resend_otp_form_submit"});
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    this.timer=30;
    var interval=setInterval(()=>{
      this.timer=this.timer-1;
      if(this.timer==0){
            clearInterval(interval)
          }
    },1000)
    this.disabled=true;
    this.cp.generatecp() 
   if(this.navParams.get("type")=='updatemobile'){
      this.type='Mobile Number and Existing Email Id'
      this.otptype='updatemobile'
      
      this.encriptedEmail=this.navParams.data.queryParams.emailid.substr(this.navParams.data.queryParams.emailid.length - 8);
       // console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.data.queryParams.emailid);
      // this.cp.generatecp()
      this.cp.generateMobileEmailOtp(loading,this.mobileNumber,this.navParams.data.queryParams.emailid).then((res)=>{loading.dismiss()
        setTimeout(()=>{
          this.disabled=false;
          if(this.timer==0){
            clearInterval(interval)
          }
        },30000)
        sessionStorage.removeItem("code");
      })
    }

    else if(this.navParams.get("type")=='updateemail'){
      this.type='Email Id and Existing Mobile Number'
      this.otptype='updateemail'
      
      this.encriptedEmail=this.navParams.get('email').substr(this.navParams.get('email').length - 8);
       // console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.get('email'));
      // this.cp.generatecp()
      this.cp.generateMobileEmailOtp(loading,localStorage.getItem("mobile"),this.navParams.get('email')).then((res)=>{
        loading.dismiss()
        setTimeout(()=>{
          this.disabled=false;
          if(this.timer==0){
            clearInterval(interval)
          }
        },30000)
      })
    }else if(this.navParams.get("type")=='updateeladline'){
      this.type='Email Id and Existing Mobile Number'
      this.otptype='updateeladline'
      
      this.encriptedEmail=this.navParams.get('email').substr(this.navParams.get('email').length - 8);
       // console.log("this.encriptedEmail",this.encriptedEmail,this.navParams.get('email'));
      // this.cp.generatecp()
      this.cp.generateMobileEmailOtp(loading,localStorage.getItem("mobile"),this.navParams.get('email')).then((res)=>{
        loading.dismiss()
        setTimeout(()=>{
          this.disabled=false;
          if(this.timer==0){
            clearInterval(interval)
          }
        },30000)
      })
    }else{
       setTimeout(()=>{
              this.cp.generateOtp(loading,this.mobileNumber).then((res)=>{loading.dismiss()
              setTimeout(()=>{
                  this.disabled=false;
                  if(this.timer==0){
                    clearInterval(interval)
                  }
                },30000)
          //sessionStorage.removeItem("code");
        })
            },1000)
       
     }
   
  }
  
  postFormValidation(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: "verify_otp_form_submit"});
    if(this.otp0!='' && this.otp1!='' && this.otp2!='' && this.otp3!='' && this.otp4!='' && this.otp5!=''){
      let mainOtp:any='';
      mainOtp=this.otp0+this.otp1+this.otp2+this.otp3+this.otp4+this.otp5;
      mainOtp = parseInt(mainOtp);
      let responcePromise = this.cp.verifyOtp(loading,mainOtp,this.mobileNumber);
      responcePromise.then((res:any)=>{
        var res=JSON.parse(res)
         loading.dismiss();
        //console.log(res);
        if(res.Error){
          this.showAlert("Error",res.Error.ErrorMessage);
        }
        else if(res.Payload.Result){
           
          this.showAlert("Success","Otp verified successfully.");
         
          if(this.navParams.get("type")=='forgot'){
            this.navCtrl.setRoot(SetNewPasswordPage,{"mobile":this.mobileNumber})
          }
          else if(this.navParams.get("type")=='updatemobile'){
            this.navCtrl.setRoot(ContactdetailsupdatePage,{"mobile":this.mobileNumber,'updatedmobile':true,queryParams:this.navParams.data.queryParams})
          }else if(this.navParams.get("type")=='updateemail'){
            console.log("this.navParams.get('email')",this.navParams.get('email'));
            this.navCtrl.setRoot(UpdateofficialemailPage,{"emailid":this.navParams.get('email'),'updatedemail':true,queryParams:this.navParams.data.queryParams})
          }else if(this.navParams.get("type")=='updateeladline'){
            console.log("this.navParams.get('updateeladline')",this.navParams.get('type'));
            
            this.navCtrl.setRoot(UpdateladlinenumberPage,{"emailid":this.navParams.get('email'),"phone_number":this.navParams.get('phone_number'),"code":this.navParams.get('code1'),"old_phone_number":this.navParams.get('old_phone_number'),'updateeladline':true,queryParams:this.navParams.data.queryParams})

          }
          else{
            this.navCtrl.setRoot(CreateNewPasswordPage,{"mobile":this.mobileNumber})
          }
          
        }
      }).catch((error:any)=>{
        //console.log(error);
        
      })
    }else{
     this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[1],true,[]);
     if(this.errorDisplay.valid){
      return false;
    }
    }
  }
  showAlert(title,msg) {

      let masg=msg;
      const alert = this.alertCtrl.create({
        title: title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/otp/otp.ts